'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var SystemStatusDemandReinitializationController = function SystemStatusDemandReinitializationController($scope, dataRetrieverService, dataRetrieverConstantsService, reinitializationService, systemStatusCommonRendererFactory, SearchCriteriaRule, $q, $state, configurationService, $log) {
  function postColumnsSuccessHandler() {
    toastr.success('Successfully saved configuration changes.');
  }
  function postColumnsErrorHandler(response) {
    var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
    $log.error('SystemStatusDemandReinitializationController: postColumnsErrorHandler - ' + errorMsg);
    toastr.error(errorMsg);
    return $q.reject();
  }
  function reloadData() {
    $scope.$broadcast('grid:dataChanged');
  }
  function setClearDemanDAdjsFlagInRows(rows) {
    _.forEach(rows, function (row) {
      row.clearDemandAdjsFlag = !_.isNil(row.clearDemandAdjsFlag) && row.clearDemandAdjsFlag === 'Yes';
    });
    return rows;
  }
  dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SYSTEM_STATUS_SCREEN, dataRetrieverConstantsService.SYSTEM_STATUS_DEMAND_REINITIALIZATION_MODE).setCustomSearchCriteriaRules([]).setRequestParameters({
    carrier: configurationService.getHostCarrier(),
    calendarName: 'ReinitDmd',
    initializationType: 'REINITIALIZATION'
  });
  $scope.reinitialize = function (event, rows) {
    reinitializationService.isDemandSmoothingAlphaAboveZero(rows).then(function (result) {
      if (result !== true) {
        $log.error('SystemStatusDemandReinitializationController: reinitializeFunction - Demand Smoothing % parameter is set to 0% for this market. Demand Initialization cannot be submitted.');
        toastr.error('Demand Smoothing % parameter is set to 0% for ' + result + ' market' + (result === 'all' ? 's' : '') + '. Demand Initialization cannot be submitted.');
        return;
      }
      $scope.demandReinitPayload = setClearDemanDAdjsFlagInRows(rows);
      reinitializationService.countExternalOverridesInProgress().then(function (result) {
        if (!result) {
          $scope.triggerReinit();
        } else {
          $scope.showModal();
        }
      });
    }, function () {
      $log.error('SystemStatusDemandReinitializationController: reinitializeFunction - error when getting DemandSmoothingAlpha');
    });
  };
  $scope.triggerReinit = function () {
    reinitializationService.reinitializeRequest($scope.demandReinitPayload, 'Demand', 'Admin', true).then(postColumnsSuccessHandler, postColumnsErrorHandler).then(reloadData);
  };
  $scope.forceAddRow = function () {
    var eventName = 'demand-reinitialization:force-add-row';
    var data = $state.params.transitionData;
    if (data) {
      var rowData = data[eventName];
      if (rowData) {
        $scope.$broadcast(eventName, rowData);
        data[eventName] = undefined;
      }
    }
  };
  $scope.customRenderers = systemStatusCommonRendererFactory;
};
SystemStatusDemandReinitializationController.$inject = ['$scope', 'DataRetrieverService', 'DataRetrieverConstantsService', 'ReinitializationService', 'SystemStatusCommonRendererFactory', 'SearchCriteriaRuleFactory', '$q', '$state', 'ConfigurationService', '$log'];
module.exports = SystemStatusDemandReinitializationController;